import type {DataRouterEditBlobPagePayload} from '@github-ui/code-view-types'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export function buildCodeViewEditRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('codeViewEditRoute', {
    path: '/:owner/:repo/edit/:branch/*',
    // when editing a file, we want to ensure we have the latest version of the file
    queries: [
      mainQuery<DataRouterEditBlobPagePayload>({
        queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: {pr: searchParams.get('pr')}}),
        navigationBehavior: 'network-first',
        encodeFetchPath: true,
      }),
    ],
    uiServiceOptions: {
      tsrConfig: {
        validateSearch: (search: Record<string, unknown>): {pr?: string} => search as {pr?: string},
      },
    },
  })
}

export const codeViewEditRoute = buildCodeViewEditRoute(codeViewAppBuilder)
